import styled from '@emotion/styled';

export const Board = styled.div`
  width: 100%;
  // background-color: #f4f5f7;
  background-color: ${({ theme }) =>
    theme.dark ? theme.bgColors.primary : '#f4f5f7'};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: var(--app-height);

  .expanded & {
    display: none;
  }
`;

export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;
